<template>
    <nav class="navbar navbar-expand-lg bg-body-tertiary main-navbar">
  <div class="container-fluid">
    <RouterLink class="navbar-brand d-flex align-items-center" to="/">
      <img src="../assets/tangerine-logo-alt.svg" width="70" height="70" >
    </RouterLink>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
        <li class="nav-item dropdown text-light">
          <a class="nav-link dropdown-toggle text-light" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Departments
          </a>
          <ul class="dropdown-menu">
            <li><RouterLink class="dropdown-item text-dark" to="/apparel">Apparel</RouterLink></li>
            <li><hr class="dropdown-divider"></li>
            <li><RouterLink class="dropdown-item text-dark" to="/electronics">Electronics</RouterLink></li>
          </ul>
        </li>
        <li class="nav-item">
          <RouterLink class="nav-link text-light" to="/create-account">Create Account</RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink class="nav-link text-light" to="/login">Login</RouterLink>
        </li>
        <li class="nav-item ms-auto me-1" style="margin: auto; text-align: right; text:white">
          <RouterLink class="nav-link text-light" to="/checkout">
            <div class="cart-wrapper">
            <i class="bi bi-bag-fill text-white fs-2"></i>
            <p class="cart-total">{{ getItems }}</p>
            </div>
            </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import {RouterLink} from 'vue-router'
export default{
    name:"NavigationBar",
    components:{
        RouterLink
    },
    computed:{
        getItems(){
            return this.$store.state.totalItemsInCart
        }
    }
}
</script>

<style scoped>
.main-navbar{
  background-color: orange !important;
  text: white !important;
}
.cart-wrapper{
  position: relative;
}
.cart-total{
  position: absolute;
  top: 2px;
  left: 14px !important;
  width: 20px;
  height: 20px;
  background-color: orange;
  color: white;
  border: solid yellow 2px;
  border-radius: 50%;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>